import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Elm } from '@features/fleets/models/elm';

@Component({
  selector: 'app-elm-data-modal',
  templateUrl: './elm-data-modal.component.html',
  styleUrls: ['./elm-data-modal.component.scss']
})
export class ElmDataModalComponent implements OnInit {

  @Input() data: Elm;
  @Output() confirmed = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

}
